import { useCallback, useState } from "react";

import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { signIn } from "next-auth/react";

import Button, { type IButtonProps } from "@musicfy/components/Button";
import Icon from "@musicfy/components/Icon";
import {
  MARKETING_OPT_IN_COOKIE,
  MARKETING_OPT_IN_COOKIE_VALUE,
} from "@musicfy/utils/marketingConsent";

import { FEATURE_ROUTES } from "./Navigation/constants";

interface IGoogleAuthButtonProps extends IButtonProps {
  marketingOptIn?: boolean;
}

const GoogleAuthButton: React.FC<IGoogleAuthButtonProps> = ({
  marketingOptIn = false,
  ...buttonProps
}) => {
  const router = useRouter();
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const handleGoogleAuthClick = useCallback(() => {
    const callbackPath = router.query.callbackPath
      ? (router.query.callbackPath as string)
      : router.asPath;

    setIsGoogleLoading(true);

    if (marketingOptIn) {
      Cookies.set(MARKETING_OPT_IN_COOKIE, MARKETING_OPT_IN_COOKIE_VALUE, {
        expires: new Date(Date.now() + 15 * 60 * 1000),
        path: "/",
        sameSite: "lax",
        secure: window.location.protocol === "https:",
      });
    } else {
      Cookies.remove(MARKETING_OPT_IN_COOKIE, { path: "/" });
    }

    signIn("google", {
      callbackUrl:
        !callbackPath || callbackPath === "/"
          ? FEATURE_ROUTES.voice
          : callbackPath,
    });
  }, [marketingOptIn, router.asPath, router.query.callbackPath]);

  return (
    <Button
      preIcon={<Icon name="google" className="w-6 h-6" />}
      onClick={handleGoogleAuthClick}
      loading={isGoogleLoading}
      {...buttonProps}
      variant="outlined"
      className="!text-white !bg-transparent"
    >
      Continue with Google
    </Button>
  );
};

export default GoogleAuthButton;
